export default "__VITE_ASSET__Byp69JG2__"